import { Directive, Input, Output, EventEmitter } from '@angular/core';

import { Rule } from '@zhongruigroup/ngx-query';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[dfNgxQueryDisableInput]',
  exportAs: 'NgxQueryDisableInputDirective'
})
export class NgxQueryDisableInputDirective {
  @Input('dfNgxQueryDisableInput') rule: Rule;
  @Input() diValue: any;
  @Output() diValueChange: EventEmitter<any> = new EventEmitter();

  private isDisable: boolean = false;
  private isDisabing: boolean = false;
  constructor() {}

  get disabled(): boolean {
    if (this.rule) {
      if (this.rule.field['canDisable'] && this.rule.field['disable']) {
        if (this.isDisabing) {
          return true;
        }
        this.isDisabing = true;
        if (!this.isDisable) {
          setTimeout(() => {
            this.diValue = '';
            this.diValueChange.emit(this.diValue);
          }, 0);
        }
        this.isDisable = true;
        this.isDisabing = false;
        return true;
      }
    }
    this.isDisable = false;
    return false;
  }
}
